import { useTranslation } from "react-i18next";
import { Box, Chip, Skeleton, Typography } from "@mui/material";

import { Entity } from "../../../../../types/types";

const AgeGroups = ({ entity, isLoading }: { entity?: Entity; isLoading: boolean }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "ageGroups" });

  return (
    <Box sx={styles.ageGroupsContainer}>
      <Typography variant="h6" sx={styles.ageGroupsTitle}>
        {t("ageGroupsServed")}
      </Typography>
      <Box sx={styles.ageGroupsList}>
        {isLoading &&
          [...Array(6)].map((_, index) => <Skeleton key={index} variant="rounded" width={50} height={28} />)}
        {!isLoading &&
          entity?.listEntry?.map(({ id, name }) => <Chip sx={styles.ageGroupChip} key={id} label={name} />)}
        {!isLoading && !entity?.listEntry?.length && (
          <Typography sx={styles.noAgeGroupsText}>{t("noAgeGroups")}</Typography>
        )}
      </Box>
    </Box>
  );
};

export default AgeGroups;

const styles = {
  ageGroupsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
    padding: "20px",
  },
  ageGroupsTitle: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  },
  ageGroupsList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
  },
  ageGroupChip: {
    fontFamily: "Montserrat",
    color: "var(--Gray-700, #344054)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "4px 12px",
    "& .MuiChip-label": {
      padding: "0",
    },
  },
  noAgeGroupsText: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
};
